/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Sales
 * Это Sales api сервер, для запросов от Frontend.  Для запросов требуется указать header с Authorization и типом Bearer.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface ResponseSaleRollback
 */
export interface ResponseSaleRollback {
  /**
   *
   * @type {boolean}
   * @memberof ResponseSaleRollback
   */
  success: boolean
  /**
   *
   * @type {string}
   * @memberof ResponseSaleRollback
   */
  errorMessage?: string
  /**
   *
   * @type {number}
   * @memberof ResponseSaleRollback
   */
  codeError?: number
}

/**
 * Check if a given object implements the ResponseSaleRollback interface.
 */
export function instanceOfResponseSaleRollback(
  value: object,
): value is ResponseSaleRollback {
  if (!('success' in value) || value['success'] === undefined) return false
  return true
}

export function ResponseSaleRollbackFromJSON(json: any): ResponseSaleRollback {
  return ResponseSaleRollbackFromJSONTyped(json, false)
}

export function ResponseSaleRollbackFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ResponseSaleRollback {
  if (json == null) {
    return json
  }
  return {
    success: json['success'],
    errorMessage:
      json['errorMessage'] == null ? undefined : json['errorMessage'],
    codeError: json['codeError'] == null ? undefined : json['codeError'],
  }
}

export function ResponseSaleRollbackToJSON(json: any): ResponseSaleRollback {
  return ResponseSaleRollbackToJSONTyped(json, false)
}

export function ResponseSaleRollbackToJSONTyped(
  value?: ResponseSaleRollback | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value
  }

  return {
    success: value['success'],
    errorMessage: value['errorMessage'],
    codeError: value['codeError'],
  }
}
